const scorecardActions = {
   UPLOAD_CANDIDATE_DATA : "UPLOAD_CANDIDATE_DATA",
   GENERATE_SCORE_DATA : "GENERATE_SCORE_DATA",
   GET_SCORE_DATA : "GET_SCORE_DATA",
   SET_SCORE_DATA : "SET_SCORE_DATA",
   SET_GENERATED_SCORE_DATA : "SET_GENERATED_SCORE_DATA",
   RESET_GENERATED_DATA:"RESET_GENERATED_DATA",
   GET_GENERATED_SCORE_DATA:"GET_GENERATED_SCORE_DATA",
};

export default scorecardActions;